import { Navigate, createBrowserRouter } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { PortalLayout } from '@/components/layout/PortalLayout';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { VendorListPage } from '@/features/vendors/VendorListPage';
import { VendorDetailPage } from '@/features/vendors/VendorDetailPage';
import { MyApprovalsPage } from '@/features/workflow/MyApprovalsPage';
import { WorkflowDefinitionEditorPage, WorkflowDefinitionListPage } from '@/features/workflow/WorkflowPages';
import { AuditLogPage, VendorInvitesPage } from '@/features/admin/AdminPages';
import { LoginPage, PortalOnboardingStatusPage, RegistrationPage } from '@/features/portal/PortalPages';
import { RequireAuth, RequirePermission } from '@/auth/RouteGuards';
import { ProcessFlowPage } from '@/features/process-flow/ProcessFlowPage';
import { NotificationsPage } from '@/features/admin/NotificationsPage';
import { IamPage } from '@/features/admin/IamPage';
import { MasterDataManagementPage } from '@/features/admin/MasterDataManagementPage';
import { AttachmentsPage } from '@/features/admin/AttachmentsPage';

function NotFound() { return <div className="not-found"><span>404</span><h1>Page not found</h1><p>The page you requested does not exist or you do not have access.</p><a className="button button--primary" href="/app">Return to overview</a></div>; }

export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/login" replace /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/portal/login', element: <LoginPage portal /> },
  { path: '/register', element: <RegistrationPage /> },
  { path: '/register/:token', element: <RegistrationPage /> },
  { element: <RequireAuth userType="INTERNAL" />, children: [
    { path: '/app', element: <AppLayout />, children: [
      { index: true, element: <DashboardPage /> },
      { path: 'approvals', element: <MyApprovalsPage /> },
      { path: 'process-flow', element: <ProcessFlowPage /> },
      { path: 'notifications', element: <NotificationsPage /> },
      { path: 'attachments', element: <AttachmentsPage /> },
      { element: <RequirePermission permission="VENDOR.VIEW" />, children: [
        { path: 'vendors', element: <VendorListPage /> },
        { path: 'vendors/:id', element: <VendorDetailPage /> },
      ] },
      { element: <RequirePermission permission="VENDOR.CREATE" />, children: [{ path: 'vendor-invites', element: <VendorInvitesPage /> }] },
      { element: <RequirePermission permission="WORKFLOW.CONFIGURE" />, children: [
        { path: 'workflows', element: <WorkflowDefinitionListPage /> },
        { path: 'workflows/:id', element: <WorkflowDefinitionEditorPage /> },
      ] },
      { element: <RequirePermission permission="USER.MANAGE" />, children: [
        { path: 'users', element: <IamPage /> },
        { path: 'settings/master-data', element: <MasterDataManagementPage /> },
        { path: 'settings/company', element: <MasterDataManagementPage initialTab="companies" /> },
        { path: 'audit', element: <AuditLogPage /> },
      ] },
    ] },
  ] },
  { element: <RequireAuth userType="VENDOR" />, children: [
    { path: '/portal', element: <PortalLayout />, children: [
      { index: true, element: <Navigate to="onboarding" replace /> },
      { path: 'onboarding', element: <PortalOnboardingStatusPage /> },
    ] },
  ] },
  { path: '*', element: <NotFound /> },
]);
